import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Select } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  PaymentMethod,
  PaymentMethodFieldsByType,
  PaymentMethodType,
  PaymentMethodTypeLabels,
} from '@/model/General/PaymentMethod';

// TODO agregar traducciones

// Labels legibles para los campos dinámicos del formulario
const fieldLabels: Record<string, string> = {
  banco: 'Banco',
  nombre_cuenta: 'Nombre de cuenta',
  numero_cuenta: 'Número de cuenta',
  cbu: 'CBU',
  alias_cbu: 'Alias CBU',
  cuit_cuil: 'CUIT/CUIL',
  clave: 'Clave',
  email_pago: 'Email de pago',
};

interface PaymentMethodCreateModalProps {
  onCreatePaymentMethod?: (data: Partial<PaymentMethod>) => void;
}

/**
 * Botón + Modal para crear un nuevo método de pago.
 * Renderiza campos dinámicos según el tipo de pago seleccionado.
 */
const PaymentMethodCreateModal = ({ onCreatePaymentMethod }: PaymentMethodCreateModalProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const selectedPaymentType = Form.useWatch('tipo', form);
  const handleOk = () => {
    void form.validateFields().then(values => {
      onCreatePaymentMethod?.(values);
      setOpen(false);
      form.resetFields();
    });
  };

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  return (
    <>
      <Button icon={<PlusOutlined />} onClick={() => setOpen(true)} />
      <Modal
        title={t('Nuevo método de pago')}
        open={open}
        onCancel={handleCancel}
        onOk={handleOk}
        okText={t('Guardar')}
        cancelText={t('Cancelar')}
        destroyOnHidden>
        <Form form={form} layout="vertical">
          <Form.Item
            name="tipo"
            label={t('Tipo de pago')}
            rules={[{ required: true, message: t('Seleccione un tipo de pago') }]}>
            <Select
              options={Object.entries(PaymentMethodTypeLabels).map(([value, label]) => ({
                value: Number(value),
                label,
              }))}
              placeholder={t('Seleccione un tipo')}
            />
          </Form.Item>
          <Form.Item
            name="descripcion"
            label={t('Descripción / Referencia')}
            rules={[
              {
                required: true,
                message: t('La {{field}} es requerida', { field: t('Descripción / Referencia') }),
              },
            ]}>
            <Input />
          </Form.Item>
          {selectedPaymentType !== undefined &&
            PaymentMethodFieldsByType[selectedPaymentType as PaymentMethodType]?.map(field => (
              <Form.Item key={field} name={field} label={t(fieldLabels[field] ?? field)}>
                <Input />
              </Form.Item>
            ))}
        </Form>
      </Modal>
    </>
  );
};

export default PaymentMethodCreateModal;
